import { HtmlHeadInclude, IRequestContext } from '@msdyn365-commerce/core';
import { isProduction } from '../../../../utils/environment-utils';
import * as React from 'react';

import { getFacebookEventsSnippet } from './helpers/get-facebook-events-snippet';
import { getGtmSnippet } from './helpers/get-gtm-snippet';
import {
    DOMAIN_REGEX,
    FACEBOOK_EVENTS_ID_REGEX,
    GTM_ID_REGEX,
    PRODUCTION_FACEBOOK_EVENTS_ID,
    PRODUCTION_GTM_ID
} from './tracking-scripts.const';

export interface ITrackingScriptsProps {
    requestContext: IRequestContext;
}

/**
 * Injects the GTM and Facebook events loaders at the start of <head>, using the IDs from app settings.
 */
export const TrackingScripts = ({ requestContext }: ITrackingScriptsProps): JSX.Element | null => {
    const isProd = isProduction(requestContext);
    const gtmId: string = requestContext.app.config.gtmId || (isProd ? PRODUCTION_GTM_ID : '');
    const facebookEventsId: string = requestContext.app.config.facebookEventsId || (isProd ? PRODUCTION_FACEBOOK_EVENTS_ID : '');
    const { canonicalDomain } = requestContext;

    // Values are inlined into a <script>, so only strict formats are allowed.
    const isGtmEnabled = GTM_ID_REGEX.test(gtmId);
    const isFacebookEventsEnabled =
        FACEBOOK_EVENTS_ID_REGEX.test(facebookEventsId) && !!canonicalDomain && DOMAIN_REGEX.test(canonicalDomain);

    if (!isGtmEnabled && !isFacebookEventsEnabled) {
        return null;
    }

    return (
        <HtmlHeadInclude>
            {isGtmEnabled && <script key='gtm' data-load-point='headStart' dangerouslySetInnerHTML={{ __html: getGtmSnippet(gtmId) }} />}
            {isFacebookEventsEnabled && (
                <script
                    key='facebook-events'
                    data-load-point='headStart'
                    dangerouslySetInnerHTML={{ __html: getFacebookEventsSnippet(facebookEventsId, canonicalDomain) }}
                />
            )}
        </HtmlHeadInclude>
    );
};
